module.exports = __webpack_public_path__ + "img/dots2.c1f260d4.svg";